import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import {
  BASE_URL,
  CORE_URL,
  SUPPORT_GET_USER,
  SUPPORT_EDIT_USER,
  SUPPORT_GET_BET,
  M_POST,
  UPDATE_SUSPEND_BY_GAME
} from '@/utils/api';

@Module({ name: 'user' })
export default class User extends VuexModule {
  @Action({ rawError: true })
  async GetUser(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: CORE_URL + SUPPORT_GET_USER,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch user failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch user failed');
    }
  }

  @Action({ rawError: true })
  async EditUser(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: CORE_URL + SUPPORT_EDIT_USER,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Edit user failed');
      return data?.data ?? data?.status;
    } catch (err: any) {
      throw toError(err, 'Edit user failed');
    }
  }

  @Action({ rawError: true })
  async GetBet(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: CORE_URL + SUPPORT_GET_BET,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch bet failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch bet failed');
    }
  }

  @Action({ rawError: true })
  async UpdateSuspendByGame(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_SUSPEND_BY_GAME,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update suspend by game failed');
      return data?.data ?? data?.status;
    } catch (err: any) {
      throw toError(err, 'Update suspend by game failed');
    }
  }
}
